/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TaskSubtaskResponseDto } from './TaskSubtaskResponseDto';
import {
    TaskSubtaskResponseDtoFromJSON,
    TaskSubtaskResponseDtoFromJSONTyped,
    TaskSubtaskResponseDtoToJSON,
    TaskSubtaskResponseDtoToJSONTyped,
} from './TaskSubtaskResponseDto';

/**
 * 
 * @export
 * @interface TaskResponseDto
 */
export interface TaskResponseDto {
    /**
     * 
     * @type {string}
     * @memberof TaskResponseDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof TaskResponseDto
     */
    organizationId?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TaskResponseDto
     */
    isShared: boolean;
    /**
     * 
     * @type {string}
     * @memberof TaskResponseDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof TaskResponseDto
     */
    workTypeId: string;
    /**
     * 
     * @type {boolean}
     * @memberof TaskResponseDto
     */
    mandatory: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TaskResponseDto
     */
    requiresShutdown: boolean;
    /**
     * 
     * @type {number}
     * @memberof TaskResponseDto
     */
    estimatedDurationMinutes?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TaskResponseDto
     */
    createdById: string;
    /**
     * 
     * @type {string}
     * @memberof TaskResponseDto
     */
    updatedById: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof TaskResponseDto
     */
    partIds: Array<string>;
    /**
     * 
     * @type {Array<TaskSubtaskResponseDto>}
     * @memberof TaskResponseDto
     */
    subtasks: Array<TaskSubtaskResponseDto>;
    /**
     * 
     * @type {Date}
     * @memberof TaskResponseDto
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof TaskResponseDto
     */
    updatedAt: Date;
}

/**
 * Check if a given object implements the TaskResponseDto interface.
 */
export function instanceOfTaskResponseDto(value: object): value is TaskResponseDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('isShared' in value) || value['isShared'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('workTypeId' in value) || value['workTypeId'] === undefined) return false;
    if (!('mandatory' in value) || value['mandatory'] === undefined) return false;
    if (!('requiresShutdown' in value) || value['requiresShutdown'] === undefined) return false;
    if (!('createdById' in value) || value['createdById'] === undefined) return false;
    if (!('updatedById' in value) || value['updatedById'] === undefined) return false;
    if (!('partIds' in value) || value['partIds'] === undefined) return false;
    if (!('subtasks' in value) || value['subtasks'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function TaskResponseDtoFromJSON(json: any): TaskResponseDto {
    return TaskResponseDtoFromJSONTyped(json, false);
}

export function TaskResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TaskResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'organizationId': json['organizationId'] == null ? undefined : json['organizationId'],
        'isShared': json['isShared'],
        'name': json['name'],
        'workTypeId': json['workTypeId'],
        'mandatory': json['mandatory'],
        'requiresShutdown': json['requiresShutdown'],
        'estimatedDurationMinutes': json['estimatedDurationMinutes'] == null ? undefined : json['estimatedDurationMinutes'],
        'createdById': json['createdById'],
        'updatedById': json['updatedById'],
        'partIds': json['partIds'],
        'subtasks': ((json['subtasks'] as Array<any>).map(TaskSubtaskResponseDtoFromJSON)),
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
    };
}

export function TaskResponseDtoToJSON(json: any): TaskResponseDto {
    return TaskResponseDtoToJSONTyped(json, false);
}

export function TaskResponseDtoToJSONTyped(value?: TaskResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'organizationId': value['organizationId'],
        'isShared': value['isShared'],
        'name': value['name'],
        'workTypeId': value['workTypeId'],
        'mandatory': value['mandatory'],
        'requiresShutdown': value['requiresShutdown'],
        'estimatedDurationMinutes': value['estimatedDurationMinutes'],
        'createdById': value['createdById'],
        'updatedById': value['updatedById'],
        'partIds': value['partIds'],
        'subtasks': ((value['subtasks'] as Array<any>).map(TaskSubtaskResponseDtoToJSON)),
        'createdAt': value['createdAt'].toISOString(),
        'updatedAt': value['updatedAt'].toISOString(),
    };
}

